<template>
  <div class="recharge-policy-page">
    <div class="breadcrumb">
      <span class="breadcrumb-item" @click="goProfile">{{ profileBreadcrumb }}</span>
      <template v-if="showBalanceBreadcrumb">
        <span class="breadcrumb-separator"> &gt; </span>
        <span class="breadcrumb-item" @click="goBalance">我的余额</span>
      </template>
      <span class="breadcrumb-separator"> &gt; </span>
      <span class="breadcrumb-item active">{{ pageTitle || defaultTitle }}</span>
    </div>

    <div class="con-box">
      <div v-if="loading" class="state state-loading">加载中…</div>
      <div v-else-if="loadError" class="state state-error">{{ loadError }}</div>
      <template v-else>
        <h1 v-if="pageTitle" class="page-title">{{ pageTitle }}</h1>
        <div
          v-if="bodyHtml"
          class="policy-content"
          v-html="bodyHtml"
        />
        <div v-else class="state state-empty">暂无说明内容</div>
      </template>
    </div>
  </div>
</template>

<script>
import { getChongzhiPolicy } from '@/api/home'
import { getPolicyTypeLabel, normalizePolicyType, POLICY_TYPE } from '@/utils/policyTypes'

function pickPolicyPayload(res) {
  if (!res) return { title: '', html: '' }
  const raw = res.data
  if (raw == null) return { title: '', html: '' }
  if (typeof raw === 'string') {
    const s = raw.trim()
    return { title: '', html: s }
  }
  if (typeof raw === 'object') {
    const title = raw.title || raw.name || ''
    const html = raw.chongzhi || raw.content || raw.detail || raw.body || raw.article || raw.text || raw.info || ''
    if (typeof html === 'string' && html.trim()) {
      return { title: String(title || '').trim(), html: html.trim() }
    }
    if (title) {
      return { title: String(title).trim(), html: '' }
    }
  }
  return { title: '', html: '' }
}

export default {
  name: 'RechargePolicy',
  data() {
    return {
      loading: true,
      loadError: '',
      pageTitle: '',
      bodyHtml: '',
      policyType: POLICY_TYPE.REGISTER
    }
  },
  computed: {
    defaultTitle() {
      return getPolicyTypeLabel(this.policyType)
    },
    showBalanceBreadcrumb() {
      return this.policyType === POLICY_TYPE.REGISTER || this.policyType === POLICY_TYPE.WITHDRAW
    },
    profileBreadcrumb() {
      const gid = Number(this.$store.getters.userInfo && this.$store.getters.userInfo.group_id)
      return gid === 2 ? '工作平台' : '个人中心'
    }
  },
  watch: {
    '$route.query.type'() {
      this.loadPolicy()
    }
  },
  created() {
    this.loadPolicy()
  },
  methods: {
    goProfile() {
      const gid = Number(this.$store.getters.userInfo && this.$store.getters.userInfo.group_id)
      if (gid === 2) {
        this.$router.push({ path: '/profile/index' })
      } else {
        this.$router.push('/profile')
      }
    },
    goBalance() {
      this.$router.push({ path: '/profile/index', query: { activeMenu: '3' }})
    },
    async loadPolicy() {
      this.policyType = normalizePolicyType(this.$route.query.type, POLICY_TYPE.REGISTER)
      this.loading = true
      this.loadError = ''
      try {
        const res = await getChongzhiPolicy({ type: this.policyType })
        const ok = res && (res.code === 1 || res.code === '1' || res.success === true)
        if (!ok) {
          this.loadError = (res && res.msg) || `获取${this.defaultTitle}失败`
          this.pageTitle = ''
          this.bodyHtml = ''
          return
        }
        const { title, html } = pickPolicyPayload(res)
        this.pageTitle = title || this.defaultTitle
        this.bodyHtml = html
      } catch (e) {
        console.error(e)
        this.loadError = '网络异常，请稍后重试'
        this.pageTitle = ''
        this.bodyHtml = ''
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.recharge-policy-page {
  width: var(--page-inner-ratio, 80%);
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
  margin: 0 auto;
  box-sizing: border-box;
}

.breadcrumb {
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
}

.breadcrumb-item {
  cursor: pointer;
  color: #1e80ff;
}

.breadcrumb-item:hover {
  text-decoration: underline;
}

.breadcrumb-item.active {
  color: #666;
  cursor: default;
}

.breadcrumb-item.active:hover {
  text-decoration: none;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #999;
}

.con-box {
  background: #fff;
  border-radius: 12px;
  padding: 28px 32px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 20px;
  line-height: 1.4;
}

.policy-content {
  font-size: 15px;
  line-height: 1.75;
  color: #606266;
  word-break: break-word;
}

.policy-content ::v-deep p {
  margin: 0 0 12px;
}

.policy-content ::v-deep img {
  max-width: 100%;
  height: auto;
}

.policy-content ::v-deep ul,
.policy-content ::v-deep ol {
  padding-left: 1.25em;
  margin: 0 0 12px;
}

.state {
  text-align: center;
  padding: 40px 16px;
  font-size: 14px;
  color: #909399;
}

.state-error {
  color: #f56c6c;
}

.state-empty {
  color: #909399;
}
</style>
